module.exports = __webpack_public_path__ + "static/media/mathiasg.7fd53338.png";